import { lazy } from 'react';

import { canViewCampusInventories, hasPpeCoordinatorRole } from '../shared/helper';

const FacilityDetailPage = lazy(() => import('./containers/FacilityDetailPage'));
const FacilityPage = lazy(() => import('./containers/FacilityPage'));
const LaundryPage = lazy(() => import('./containers/LaundryPage'));
const LaundryDetailPage = lazy(() => import('./containers/LaundryDetailPage'));

const routes = {
  auth: ({ profile } = {}) => Boolean(profile),
  routes: [
    {
      path: '/location-area/facility/:facilityId',
      auth: ({ profile }) => canViewCampusInventories(profile.campusCode, profile),
      component: FacilityDetailPage,
    },
    {
      path: '/location-area/facility',
      auth: ({ profile }) => canViewCampusInventories(profile.campusCode, profile),
      component: FacilityPage,
    },
    {
      path: '/location-area/laundry/:laundryId',
      auth: ({ profile }) => hasPpeCoordinatorRole(profile),
      component: LaundryDetailPage,
    },
    {
      path: '/location-area/laundry',
      component: LaundryPage,
    },
  ],
};

export default routes;
